import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ArrowsRightLeftIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/arrows-right-left"><path id="Icon" d="M7.5 12L3 16.5L7.5 21M3 16.5H16.5M16.5 12L21 7.5L16.5 3M21 7.5L7.5 7.5" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ArrowsRightLeftIcon;